import axios from 'axios';

export const aiImportSetting = {
    namespaced: true,
    state: {
        importSetting: {},
        importSettingLoaded: false,
    },
    getters: {
        importSetting: function (state) {
            return state.importSetting;
        },
        importSettingLoaded: function (state) {
            return state.importSettingLoaded;
        },
    },
    actions: {
        importSetting: function (context) {
            return new Promise((resolve, reject) => {
                axios.get('admin/setting/ai-import', {
                    params: {
                        _ts: Date.now(),
                    },
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        Pragma: 'no-cache',
                        Expires: '0',
                    },
                }).then((res) => {
                    context.commit('importSetting', res.data.data);
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        importSettings: function (context) {
            return context.dispatch('importSetting');
        },
        importSettingCached: function (context) {
            return new Promise((resolve, reject) => {
                if (context.state.importSettingLoaded) {
                    resolve({ data: { data: context.state.importSetting } });
                    return;
                }

                context.dispatch('importSetting').then(resolve).catch(reject);
            });
        },
        importSettingRefresh: function (context) {
            return new Promise((resolve, reject) => {
                context.dispatch('importSetting').then(resolve).catch(reject);
            });
        },
        saveImportSetting: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.put('admin/setting/ai-import', payload).then((res) => {
                    context.commit('importSetting', res.data.data);
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        saveImportSettings: function (context, payload) {
            return context.dispatch('saveImportSetting', payload);
        },
    },
    mutations: {
        importSetting: function (state, payload) {
            state.importSetting = payload;
            state.importSettingLoaded = true;
        },
    },
};
